import './style.css'
import { DoubleRing } from '../loading'
export const LoadingOverlay: React.VFC = () => {
  return (
    <div className="loading-overlay">
      <div className="spinner"></div>
    </div>
  )
}
